import { handleSignupTracking } from 'helpers/Tracking';
import React, { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';

export type FormVariant = 'none' | 'dark' | 'light';

type SignupGeoWrapperProps = {
    formVariant: FormVariant;
    formId: string;
};

export const SignupForm = (props: SignupGeoWrapperProps) => {
    const { formId = 'ffa9c1e1-a0bf-47fe-82c2-2d4c668d6bca' } = props;
    const [ref, inView] = useInView({
        threshold: 0.1,
        initialInView: false,
        triggerOnce: true
    });

    const loadApolloMeetingsScript = () => {
        const script = document.createElement('script');
        script.id = 'ApolloMeetingsScript';
        script.src = 'https://assets.apollo.io/js/meetings/meetings-widget.js';
        document.body.appendChild(script);

        script.addEventListener('load', () => {
            // @ts-ignore
            if (window.ApolloMeetings) {
                //@ts-ignore
                window.ApolloMeetings.initWidget({
                    appId: '66a0d95532062501b2d9bd5b',
                    schedulingLink: 'hij-8rp-n92'
                });
            }
        });
    };

    useEffect(() => {
        if (inView) {
            const script = document.createElement('script');
            script.src = 'https://js.hsforms.net/forms/v2.js';
            document.body.appendChild(script);

            script.addEventListener('load', () => {
                // @TS-ignore
                if (window.hbspt) {
                    // @TS-ignore
                    window.hbspt.forms.create({
                        target: '#hubspotForm',
                        region: 'eu1',
                        portalId: '143190902',
                        formId: formId,
                        sfdcCampaignId: '7015J000000DeQYQA0',
                        onFormSubmitted: (e, data) => {
                            handleSignupTracking(data);
                        },
                        onFormReady: () => {
                            loadApolloMeetingsScript();
                        }
                    });
                }
            });
        }
    }, [inView]);

    const { formVariant } = props;

    const getFormClassesFromVariant = () => {
        switch (formVariant) {
            case 'dark':
                return 'tw-bg-neutral-inverse tw-text-neutral-inverse tw-border-2 tw-border-primary';
            case 'light':
                return 'tw-bg-neutral-body tw-border-3 tw-border-neutral';
            case 'none':
                return 'tw-bg-none';
            default:
                return 'tw-bg-none';
        }
    };

    return (
        <div ref={ref}>
            <div
                className={`${getFormClassesFromVariant()} tw-p-16 tw-rounded tw-shadow-xs tw-min-h-[450px]`}
            >
                <div id="hubspotForm"></div>
            </div>
            <div className="tw-text-neutral-dark-subdued tw-mt-12 tw-px-24 lg:tw-py-0 tw-py-24">
                <p className="tw-text-xs">
                    By submitting this form, you consent to be contacted on how SalesScreen can help
                    your organization.
                </p>
            </div>
        </div>
    );
};
